//src/components/ProcessSteps.jsx :-
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import axios from "axios";
import { Card, CardHeader, CardBody, CardTitle, CardText } from "reactstrap";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { ArrowForward, CheckCircle, MoreVert, ArrowBack } from "@mui/icons-material"; // Import MoreVert Icon
import { Badge} from "reactstrap"; 
import {
  Container,
  CardContent,
  Typography,
  Grid,
  Chip,
  Button,
  CircularProgress,
  Box,
  IconButton,
  Drawer,
  Menu,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Collapse,
  TextField, Paper, TableContainer
} from "@mui/material";
import { Tabs, Tab } from "@mui/material";
import { green, orange, red, grey } from "@mui/material/colors";
import env from "react-dotenv";
import ProgressCardForm from "./ProgressCardForm";
import { Refresh } from "@mui/icons-material"; // Import Refresh Icon

const getStatusColor = (status) => {
  switch (status?.toLowerCase()) {
    case "completed":
      return green[500];
    case "in progress":
      return orange[500];
    case "pending":
      return red[500];
    default:
      return grey[500];
  }
};

const ProcessSteps = ({card}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { cardDetails, department, operatorFullName } = location.state || {};
  const [departmentDetails, setDepartmentDetails] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const [bomOpen, setBomOpen] = useState(true);
  const [progressFormOpen, setProgressFormOpen] = useState(true);
  const [bomDetails, setBomDetails] = useState([]);
  const [productId, setproductId] = useState('');
  const [expandedDrawer, setExpandedDrawer] = useState(false);

  const [products, setProducts] = useState([]);
  const [quantity, setQuantity] = useState('');
  const [vendors, setVendors] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState('');
  const [grnDetails, setGrnDetails] = useState([]);
  const [selectedGRN, setSelectedGRN] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const [selectedStep, setSelectedStep] = useState(null);
  const [loading, setLoading] = useState(true);
  const [steps, setSteps] = useState([]);
  const [currentStep, setCurrentStep] = useState(null);
  const [matchedStep, setMatchedStep] = useState(null);
  const [issuedDetails, setIssuedDetails] = useState([]);
  const [bomChemicals, setBomChemicals] = useState([]); // New state for chemicals
  const [selectedTab, setSelectedTab] = useState(0); // 0 for BOM Details, 1 for Chemicals, 2 for Inventory
  const [chemicalsOpen, setChemicalsOpen] = useState(true); // State for chemicals section
  const [issueSource, setIssueSource] = useState(null); // 'bom' or 'chemical'
  const [inventoryData, setInventoryData] = useState([]);
  const user = useSelector((state) => state.user);

  const role = user.role;
  const userName = user.userName;
  const userId = user.id;

  const formatJobCardId = (card) => {
    const date = new Date(card.created_date); // Assuming created_date is the date field
    const month = date.toLocaleString('default', { month: '2-digit' }); // Get month in 2-digit format
    const year = date.getFullYear(); // Get the full year
    return `${month}/${year}/${card.product_name}/${card.job_card_id}`;
  };

  // Inside the department steps mapping logic
useEffect(() => {
  if (departmentDetails?.steps && cardDetails?.steps) {
    const lastPendingStep = cardDetails.steps.find((s) => s.step_status === "pending");
    setCurrentStep(lastPendingStep);
  }
}, [departmentDetails, cardDetails]);

// console.log("Department step details: ", departmentDetails);
// console.log("Card details: ", cardDetails);

  useEffect(() => {
    if (department && department.dept_id) {
      axios
        .get(`${process.env.REACT_APP_PJCBACKEND_URL}/api/department/${department.dept_id}`)
        .then((response) => {
          setDepartmentDetails(response.data);
        })
        .catch((error) => {
          console.error("There was an error fetching the department details!", error);
        });
    }
  }, [department]);

  useEffect(() => {
    if (productId) {
      fetchVendorsList(productId);
    }
  }, [productId]);

  const fetchVendorsList = async (productId) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_PJCBACKEND_URL}/api/receive/${productId}`);
      setVendors(response.data);
    } catch (error) {
      console.error('Error fetching vendors:', error);
    }
  };

  useEffect(() => {
  axios.get(`${process.env.REACT_APP_PJCBACKEND_URL}/api/productionlocinventory/quantities/all`)
    .then(res => {
      setInventoryData(res.data); // Store in state
    })
    .catch(err => console.error("Error fetching inventory quantities", err));
}, []);

  // const fetchGRNDetails = async (productId, vendorId) => {
  //   try {
  //     const response = await axios.get(`${process.env.REACT_APP_PJCBACKEND_URL}/api/issue/grn-details`, {
  //       params: { productId, vendorId },
  //     });
  //     setGrnDetails(response.data);
  //   } catch (error) {
  //     console.error("Error fetching GRN details:", error);
  //     setGrnDetails([]);
  //   }
  // };

  // useEffect(() => {
  //   if (productId && selectedVendor) {
  //     fetchGRNDetails(productId, selectedVendor);
  //   }
  // }, [productId, selectedVendor]);

  const fetchGRNDetails = async (productId) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_PJCBACKEND_URL}/api/issue/grn-details-summary`, {
        params: { productId },
      });
      setGrnDetails(response.data);
    } catch (error) {
      console.error("Error fetching GRN details:", error);
      setGrnDetails([]);
    }
  };

  useEffect(() => {
    if (productId) {
      fetchGRNDetails(productId);
    }
  }, [productId]);

  // const handleUpdateQuantity = async (action) => {
  //   if (!productId || !quantity || quantity <= 0 || !selectedVendor || !selectedGRN) {
  //     alert('Please provide valid product, quantity, vendor, and GRN details.');
  //     return;
  //   }

  //   const selectedGRNDetails = grnDetails.find(grn => grn.grn_no === selectedGRN);

  //   if (!selectedGRNDetails) {
  //     alert('Invalid GRN selected.');
  //     return;
  //   }

  //   if (selectedGRNDetails.balance_quantity === 0) {
  //     alert('The selected GRN has no remaining balance.');
  //     return;
  //   }

  //   if (parseInt(quantity, 10) > selectedGRNDetails.balance_quantity) {
  //     alert('The entered quantity exceeds the remaining balance of the selected GRN.');
  //     return;
  //   }

  //   try {
  //     const userName = cardDetails.current_operator_name; // Extracts the value correctly
  //     await axios.patch(
  //       `${process.env.REACT_APP_PJCBACKEND_URL}/api/products/update-quantity-issue`,
  //       {
  //         productId,
  //         quantity: parseInt(quantity, 10),
  //         action,
  //         userName,
  //         vendorId: selectedVendor,
  //         grnNo: selectedGRNDetails.grn_no,
  //         grnDate: selectedGRNDetails.grn_date,
  //         plan_id: cardDetails.plan_id,
  //         job_card_id: cardDetails.job_card_id
  //       }
  //     );
  //     alert('Product Issued Successfully.');
  //     // window.location.reload();
  //     // navigate('/process-steps');
  //     // setIsSaving(false);
  //     // setTimeout(() => {
  //     //   window.location.reload();
  //     // }, 60);
  //   } catch (error) {
  //     console.error('Error updating quantity:', error);
  //     alert('Failed to update quantity. Please try again.');
  //   } finally {
  //     setIsSaving(false);
  //   }
  // };

//   const handleUpdateQuantity = async (action) => {
//     if (!productId || !quantity || quantity <= 0 || !selectedVendor || !selectedGRN) {
//         alert('Please provide valid product, quantity, vendor, and GRN details.');
//         return;
//     }

//     const selectedGRNDetails = grnDetails.find(grn => grn.grn_no === selectedGRN);

//     if (!selectedGRNDetails) {
//         alert('Invalid GRN selected.');
//         return;
//     }

//     if (selectedGRNDetails.balance_quantity === 0) {
//         alert('The selected GRN has no remaining balance.');
//         return;
//     }

//     if (parseInt(quantity, 10) > selectedGRNDetails.balance_quantity) {
//         alert('The entered quantity exceeds the remaining balance of the selected GRN.');
//         return;
//     }

//     try {
//         const userName = cardDetails.current_operator_name; // Extracts the value correctly
//         await axios.patch(
//             `${process.env.REACT_APP_PJCBACKEND_URL}/api/products/update-quantity-issue`,
//             {
//                 productId,
//                 quantity: parseInt(quantity, 10),
//                 action,
//                 userName,
//                 vendorId: selectedVendor,
//                 grnNo: selectedGRNDetails.grn_no,
//                 grnDate: selectedGRNDetails.grn_date,
//                 plan_id: cardDetails.plan_id,
//                 job_card_id: cardDetails.job_card_id
//             }
//         );
//         alert('Product Issued Successfully.');

//         // Refresh the issued details
//         fetchProductDetails(); // Call the function to refresh the drawer data
//           setExpandedDrawer(false); // Close expanded drawer
//           setproductId(''); // Reset productId
//           setSelectedVendor(''); // Reset selectedVendor
//           setSelectedGRN(''); // Reset selectedGRN
//           setQuantity(''); // Reset quantity

//     } catch (error) {
//         console.error('Error updating quantity:', error);
//         alert('Failed to update quantity. Please try again.');
//     } finally {
//         setIsSaving(false);
//     }
// };

// console.log("Proccess Name: ", cardDetails.current_step_name);

const getOldestNonZeroGRN = () => {
  const validGRNs = grnDetails
    .filter(grn => grn.balance_quantity > 0) // Filter for positive balance quantities
    .sort((a, b) => new Date(a.grn_date) - new Date(b.grn_date)); // Sort by date
  return validGRNs.length > 0 ? validGRNs[0] : null; // Return the oldest one or null if none found
};

const handleUpdateQuantity = async (action) => {
  if (!productId || !quantity || quantity <= 0 || !selectedGRN) {
    alert('Please provide valid product, quantity, and GRN details.');
    return;
  }

  const selectedGRNDetails = grnDetails.find(grn => grn.grn_no === selectedGRN);
  const oldestGRN = getOldestNonZeroGRN();

  if (!selectedGRNDetails) {
    alert('Invalid GRN selected.');
    return;
  }

  if (selectedGRNDetails.balance_quantity === 0) {
    alert('The selected GRN has no remaining balance.');
    return;
  }

  if (parseInt(quantity, 10) > selectedGRNDetails.balance_quantity) {
    alert('The entered quantity exceeds the remaining balance of the selected GRN.');
    return;
  }

  // Check if the selected GRN is the oldest one with a non-zero quantity
  if (oldestGRN && selectedGRNDetails.grn_no !== oldestGRN.grn_no) {
    alert(`Please choose the oldest Quantity: ${oldestGRN.balance_quantity} | GRN No: ${oldestGRN.grn_no} | GRN Date: ${new Date(oldestGRN.grn_date).toLocaleDateString()}`);
    return;
  }

  try {
    // const userName = cardDetails.current_operator_name; // Extracts the value correctly
    const userName = user.userName; // Correctly assign userName from user object
    const parsedQuantity = parseInt(quantity, 10); // Ensure quantity is a number

    await axios.patch(
      `${process.env.REACT_APP_PJCBACKEND_URL}/api/products/update-quantity-issue-from-bom`,
      {
        productId,
        quantity: parsedQuantity, // Use the parsed quantity
        action,
        userName,
        grnNo: selectedGRNDetails.grn_no,
        grnDate: selectedGRNDetails.grn_date,
        plan_id: cardDetails.plan_id,
        job_card_id: cardDetails.job_card_id,
        process_name: cardDetails.current_step_name
      }
    );
    alert('Raw Material Issued Successfully.');

    // Refresh the issued details
    fetchProductDetails(); // Call the function to refresh the drawer data
    setExpandedDrawer(false); // Close expanded drawer
    setproductId(''); // Reset productId
    setSelectedGRN(''); // Reset selectedGRN
    setQuantity(''); // Reset quantity

  } catch (error) {
    console.error('Error updating quantity:', error);
    alert('Failed to update quantity. Please try again.');
  } finally {
    setIsSaving(false);
  }
};

  // const handleOpenDrawer = (card) => {
  //   setSelectedCard(card);
  //   setDrawerOpen(true);
  // };

  // const handleOpenDrawer = (card) => {
  //   setSelectedCard(card);
  //   setDrawerOpen(true);
  
  //   // Fetch BOM details based on product_id
  //   axios
  //     .get(`${process.env.REACT_APP_PJCBACKEND_URL}/api/bomDetails/bom-details`)
  //     .then((response) => {
  //       // Filter BOM details by matching product name
  //       // const filteredBOM = response.data.filter(bom => bom.main_product_name === card.product_name);
  //       const filteredBOM = response.data.filter(bom => bom.product_id === card.product_id);
  //       setBomDetails(filteredBOM);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching BOM details:", error);
  //     });
  // }; 

  const aggregateChemicals = (bomDetails, cardQuantity) => {
    const chemicalMap = {};
  
    bomDetails.forEach(bom => {
      if (bom.chemicals && bom.chemicals.length > 0) {
        const quantityRequired = bom.quantity_required; // Get the quantity required for the part
        bom.chemicals.forEach(chemical => {
          const totalQuantity = chemical.chemical_quantity * quantityRequired * cardQuantity; // Calculate total quantity
  
          // Check if the chemical name already exists in the map
          if (chemicalMap[chemical.chemical_name]) {
            chemicalMap[chemical.chemical_name].chemical_quantity += totalQuantity; // Sum the total quantities
          } else {
            // Initialize the entry with the chemical_id and total quantity
            chemicalMap[chemical.chemical_name] = {
              chemical_id: chemical.chemical_id, // Store the chemical ID
              chemical_quantity: totalQuantity // Initialize the total quantity
            };
          }
        });
      }
    });
  
    // Convert the map to an array of objects
    return Object.entries(chemicalMap).map(([name, data]) => ({
      chemical_name: name,
      chemical_id: data.chemical_id, // Include the chemical ID
      chemical_quantity: data.chemical_quantity,
    }));
  };
  
  const handleOpenDrawer = (card, matchedStep) => {
    setSelectedCard(card);
    setMatchedStep(matchedStep); // Set the matchedStep state
    setDrawerOpen(true);
  
    // Fetch BOM details based on product_id
    axios
      .get(`${process.env.REACT_APP_PJCBACKEND_URL}/api/bomDetails/bom-details`)
      .then((response) => {
        const filteredBOM = response.data.filter(bom => bom.product_id === card.product_id);
        setBomDetails(filteredBOM);

      // Aggregate chemicals from the filtered BOM
      const aggregatedChemicals = aggregateChemicals(filteredBOM, cardDetails.quantity); // Pass cardDetails.quantity
      setBomChemicals(aggregatedChemicals); // Set the aggregated chemicals
    })
      .catch((error) => {
        console.error("Error fetching BOM details:", error);
      });
};

//   useEffect(() => {
//     const fetchStepsAndJobCardDetails = async () => {
//         try {
//             const stepsResponse = await axios.get(
//                 `${process.env.REACT_APP_PJCBACKEND_URL}/api/job-cards/department/${department.dept_id}/steps/${cardDetails.job_card_id}`
//             );
//             const filteredSteps = stepsResponse.data.filter(
//                 (step) => step.job_card_id === cardDetails.job_card_id
//             );
//             setSteps(filteredSteps);
//         } catch (err) {
//             console.error("Error fetching steps:", err);
//         } finally {
//             setLoading(false);
//         }
//     };

//     fetchStepsAndJobCardDetails();
// }, [department.dept_id, cardDetails.job_card_id]);

useEffect(() => {
  const fetchStepsAndJobCardDetails = async () => {
      try {
          const stepsResponse = await axios.get(
              `${process.env.REACT_APP_PJCBACKEND_URL}/api/job-cards/department/${department.dept_id}/steps/${cardDetails.job_card_id}`
          );
          const filteredSteps = stepsResponse.data.filter(
              (step) => step.job_card_id === cardDetails.job_card_id
          );

          // Filter unique steps based on step_name
          const uniqueSteps = Array.from(new Set(filteredSteps.map(step => step.step_name)))
              .map(name => filteredSteps.find(step => step.step_name === name));

          setSteps(uniqueSteps);
      } catch (err) {
          console.error("Error fetching steps:", err);
      } finally {
          setLoading(false);
      }
  };

  if (department && cardDetails) {
      fetchStepsAndJobCardDetails();
  }
}, [department, cardDetails]);

// useEffect(() => {
//   const fetchProductDetails = async () => {
//     if (cardDetails?.plan_id && cardDetails?.job_card_id && bomDetails.length > 0) {
//       try {
//         const response = await axios.get(`${process.env.REACT_APP_PJCBACKEND_URL}/api/issue/product-details`, {
//           params: {
//             plan_id: cardDetails.plan_id,
//             job_card_id: cardDetails.job_card_id
//           }
//         });
//         setIssuedDetails(response.data); // Update state with fetched data
//       } catch (error) {
//         console.error("Error fetching Issued GRN details:", error);
//       }
//     }
//   };

//   fetchProductDetails();
// }, [cardDetails, bomDetails]);

// Function to fetch product details
const fetchProductDetails = async () => {
  if (cardDetails?.plan_id && cardDetails?.job_card_id && bomDetails.length > 0) {
      try {
          const response = await axios.get(`${process.env.REACT_APP_PJCBACKEND_URL}/api/issue/product-details-summary`, {
              params: {
                  plan_id: cardDetails.plan_id,
                  job_card_id: cardDetails.job_card_id
              }
          });
          setIssuedDetails(response.data); // Update state with fetched data
      } catch (error) {
          console.error("Error fetching Issued GRN details:", error);
      }
  }
};

useEffect(() => {
      if (cardDetails?.plan_id && cardDetails?.job_card_id && bomDetails.length > 0) {
        fetchProductDetails();
      }
  }, [cardDetails, bomDetails]);

const markAsDone = async (step) => {
  // console.log("Step details:", step);
  // console.log("job_card_id:", cardDetails.job_card_id);
  // console.log("step_id:", step.step_id);
  // console.log("step_name:", step.step_name);
  // console.log("dept_name:", step.dept_name);
  // console.log("operator_id:", cardDetails.operator_id);

  try {
      const response = await axios.post(
          `${process.env.REACT_APP_PJCBACKEND_URL}/api/job-cards/mark-as-done-new`,
          {
              job_card_id: cardDetails.job_card_id,
              step_id: step.step_id, // Corrected
              step_name: step.step_name,
              dept_name: step.dept_name,
              operator_id: cardDetails.operator_id,
          }
      );
      alert(response.data.message);
      navigate(`/view-job-card/${cardDetails?.plan_id}`);
      // window.location.href = "/process-steps";
  } catch (err) {
      console.error("Error marking as done:", err);
      alert("Error marking step as done.");
  }
};

// Function to check if all steps are completed
const areAllStepsCompleted = () => {
  if (!departmentDetails || !departmentDetails.steps) return false;

  // Get all steps for the current department
  const departmentSteps = departmentDetails.steps.map(step => {
    return cardDetails.steps.find(s => s.step_name === step);
  });

  // Check if all steps are completed
  return departmentSteps.every(step => step?.step_status === "completed");
};

// Use this function to determine if the button should be disabled
const allStepsCompleted = areAllStepsCompleted();

  return (
    <div className="container mt-4">
      {/* Back Button */}
      <div className="d-flex align-items-center mb-3">
  <IconButton
    sx={{
      backgroundColor: grey[200],
      color: "black",
      "&:hover": { backgroundColor: grey[250] },
      fontSize: "0.775rem",
      height: "36px",
      width: "36px",
      marginLeft:"210px",
      marginRight:"150px",
      marginTop: "85px",
    }}
    onClick={() => navigate(-1)}
  >
    <ArrowBack />
  </IconButton>
  <h5 className="mb-0 ms-3">Production Plan ID: {cardDetails?.plan_id || "N/A"}</h5>
</div>

      {/* Centered Card */}
      <div className="d-flex justify-content-center">
        {cardDetails ? (
          <Card className="shadow-sm" style={{ width: "400px" }}>
            <CardHeader className="bg-pramary">
  <Box display="flex" justifyContent="space-between" alignItems="center">
    {/* <Typography variant="h6" fontWeight="bold" sx={{ fontSize: "0.90rem" }}>
      Job Card ID: {cardDetails?.job_card_id || "N/A"}
    </Typography> */}
    <Typography variant="h6" fontWeight="bold" sx={{ fontSize: "0.90rem" }}>
      {formatJobCardId(cardDetails) || "N/A"}
    </Typography>
    <Chip
      label={cardDetails?.job_card_status || "N/A"}
      sx={{
        backgroundColor: getStatusColor(cardDetails?.job_card_status),
        color: "#fff",
        fontSize: "0.775rem",
      }}
    />
  </Box>
  <Box display="flex" sx={{ marginTop: "4px" }}>
      <Typography
        variant="body1"
        fontWeight="bold"
        sx={{ color: grey[600], width: "135px", fontSize: "0.775rem" }}
      >
        {cardDetails.product_name}:
      </Typography>
      <Typography variant="body1" fontWeight="bold" sx={{ color: grey[600], fontSize: "0.775rem" }}>
        {cardDetails.quantity} Units
      </Typography>
    </Box>
  
    <Box display="flex" sx={{ marginTop: "4px" }}>
      <Typography
        variant="body1"
        fontWeight="bold"
        sx={{ color: grey[600], width: "135px", fontSize: "0.775rem" }}
      >
        Assignee:
      </Typography>
      {/* <Typography variant="body1" fontWeight="bold" sx={{ color: grey[600], fontSize: "0.775rem" }}>
        {cardDetails.current_operator_name}
      </Typography> */}
      <Typography variant="body1" fontWeight="bold" sx={{ color: grey[600], fontSize: "0.775rem" }}>
        {operatorFullName || "Not assigned"}
      </Typography>
    </Box>
  
    <Box display="flex" sx={{ marginTop: "4px" }}>
      <Typography
        variant="body1"
        fontWeight="bold"
        sx={{ color: grey[600], width: "135px", fontSize: "0.775rem" }}
      >
        Current Department:
      </Typography>
      {/* <Typography variant="body1" fontWeight="bold" sx={{ color: grey[600], fontSize: "0.775rem" }}>
        {department.dept_name}
      </Typography> */}
      {/* <Typography variant="body1" fontWeight="bold" sx={{ color: grey[600], fontSize: "0.775rem" }}>
        {cardDetails.current_dept_name}
      </Typography> */}
      <Typography variant="body1" fontWeight="bold" sx={{ color: grey[600], fontSize: "0.775rem" }}>
        {cardDetails.current_dept_info}
      </Typography>
    </Box>
  
    {/* <Box display="flex" sx={{ marginTop: "4px" }}>
      <Typography
        variant="body1"
        fontWeight="bold"
        sx={{ color: grey[600], width: "135px", fontSize: "0.775rem" }}
      >
        Current Process:
      </Typography>
      <Typography variant="body1" fontWeight="bold" sx={{ color: grey[600], fontSize: "0.775rem" }}>
        {cardDetails.current_step_name}
      </Typography>
    </Box> */}
</CardHeader>

            <CardBody>
              {/* <CardText><strong>Product Name:</strong> {cardDetails.product_name}</CardText>
              <CardText><strong>Units:</strong> {cardDetails.quantity}</CardText>
              <CardText><strong>Assignee:</strong> {cardDetails.operator_name || "Not Assigned"}</CardText>
              <CardText><strong>Current Department:</strong> {department.dept_name || "Not Available"}</CardText>
              <CardText><strong>Current Process:</strong> {cardDetails.current_step_name || "Not Available"}</CardText> */}
<Box
  sx={{
    backgroundColor: "#fff",
    padding: "8px",
    // borderBottom: `2px solid ${grey[300]}`,
  }}
>
{/* Displaying department steps */}
{departmentDetails && departmentDetails.steps && departmentDetails.steps.length > 0 ? (
  <div>
    <ul style={{ listStyle: "none", padding: 0 }}>
      {/* {departmentDetails.steps.map((step, index) => {
        const matchedStep = cardDetails.steps.find((s) => s.step_name === step); */}
        {Array.from(new Set(departmentDetails.steps)).map((step, index) => {
          const matchedStep = cardDetails.steps.find((s) => s.step_name === step);
        const statusColor =
          matchedStep?.step_status === "completed"
            ? "success"
            : matchedStep?.step_status === "pending"
            ? "danger"
            : "secondary";

        return (
          <React.Fragment key={index}>
            <li className="d-flex align-items-center mb-3" style={{ display: 'flex', justifyContent: 'space-between' }}>
              <span className="me-2">{step}</span>
              
              {/* Align badge and arrow button */}
              <div style={{ display: 'flex', alignItems: 'center', width: '100px', justifyContent: 'space-between' }}>
                <Badge color={statusColor} className="px-2 py-1" sx={{ minWidth: '80px' }}>
                  {matchedStep?.step_status || "Not Started"}
                </Badge>

                {/* Conditionally render the arrow button based on statusColor */}
                {statusColor !== "secondary" && (
                  <button
                    className="ms-2 border-0 bg-transparent"
                    onClick={() => {
                      handleOpenDrawer(cardDetails, matchedStep); // Pass matchedStep here
                    }}
                    style={{ marginLeft: "2px" }}
                  >
                    <FaArrowRight size={16} color="blue" />
                  </button>
                )}
              </div>
            </li>
            <hr />
          </React.Fragment>
        );
      })}
    </ul>
  </div>
) : (
  <p>No steps available for this department.</p>
)}
</Box>

              {/* Close Production Button + Vertical Dots Icon */}
                                  <Box
                                    sx={{
                                      textAlign: "left",
                                      mt: 1,
                                      padding: "8px",
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
{/* <Button
      variant="outlined"
      size="small"
      onClick={() => markAsDone(currentStep)}
      disabled={!currentStep || allStepsCompleted || isSaving}
      sx={{
        borderColor: "green", // Set the border color to green
        color: "green", // Set the text color to green
        "&:hover": {
          backgroundColor: "rgba(0, 128, 0, 0.1)", // Optional: Light green background on hover
          borderColor: "green", // Keep the border color green on hover
        },
        paddingLeft: "10px",
        paddingRight: "10px",
        fontSize: "0.775rem",
        height: "36px",
      }}
    >
      Mark as Done
    </Button> */}
              
                                    {/* Vertical 3 Dots Icon */}
                                    <IconButton
                                      sx={{
                                        color: grey[600],
                                        // marginLeft: "10px",
                                        marginLeft: "320px",
                                      }}
                                    >
                                      <MoreVert />
                                    </IconButton>
                                  </Box>
            </CardBody>
          </Card>
        ) : (
          <p className="text-center text-muted">No card details available.</p>
        )}
      </div>

<Drawer
  anchor="right"
  open={drawerOpen}
  onClose={() => {
    setDrawerOpen(false);
    setExpandedDrawer(false);
    setproductId(null);
  }}
  sx={{
    "& .MuiDrawer-paper": {
      width: expandedDrawer ? "800px" : "600px", // Expand when form is open
      transition: "width 0.3s ease-in-out",
    },
  }}
>
  <Box sx={{ width: "100%", padding: 1, position: "relative", minHeight: "100vh" }}>
    {/* Header */}
    <Box sx={{ borderBottom: `2px solid ${grey[300]}`, paddingBottom: 1, backgroundColor: grey[100], padding: "8px" }}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        {/* <Typography variant="h6" fontWeight="bold" sx={{ fontSize: "0.90rem" }}>
          Job Card ID: {cardDetails?.job_card_id || "N/A"}
        </Typography> */}
        <Typography variant="h6" fontWeight="bold" sx={{ fontSize: "0.90rem" }}>
          {formatJobCardId(cardDetails) || "N/A"}
        </Typography>
        <Chip
          label={cardDetails?.job_card_status || "N/A"}
          sx={{
            backgroundColor: getStatusColor(cardDetails?.job_card_status),
            color: "#fff",
            fontSize: "0.775rem",
          }}
        />
      </Box>

      <Box display="flex" sx={{ marginTop: "2px" }}>
        <Typography
          variant="body1"
          fontWeight="bold"
          sx={{ color: grey[600], width: "135px", fontSize: "0.775rem" }}
        >
          {cardDetails.product_name}:
        </Typography>
        <Typography variant="body1" fontWeight="bold" sx={{ color: grey[600], fontSize: "0.775rem" }}>
          {cardDetails.quantity} Units
        </Typography>
      </Box>

      <Box display="flex" sx={{ marginTop: "2px" }}>
        <Typography
          variant="body1"
          fontWeight="bold"
          sx={{ color: grey[600], width: "135px", fontSize: "0.775rem" }}
        >
          Assignee:
        </Typography>
        {/* <Typography variant="body1" fontWeight="bold" sx={{ color: grey[600], fontSize: "0.775rem" }}>
          {cardDetails.current_operator_name}
        </Typography> */}
        <Typography variant="body1" fontWeight="bold" sx={{ color: grey[600], fontSize: "0.775rem" }}>
          {operatorFullName || "Not assigned"}
        </Typography>
      </Box>

      <Box display="flex" sx={{ marginTop: "2px" }}>
        <Typography
          variant="body1"
          fontWeight="bold"
          sx={{ color: grey[600], width: "135px", fontSize: "0.775rem" }}
        >
          Current Department:
        </Typography>
        {/* <Typography variant="body1" fontWeight="bold" sx={{ color: grey[600], fontSize: "0.775rem" }}>
          {department.dept_name}
        </Typography> */}
        {/* <Typography variant="body1" fontWeight="bold" sx={{ color: grey[600], fontSize: "0.775rem" }}>
        {cardDetails.current_dept_name}
      </Typography> */}
      <Typography variant="body1" fontWeight="bold" sx={{ color: grey[600], fontSize: "0.775rem" }}>
        {cardDetails.current_dept_info}
      </Typography>
      </Box>

      {/* <Box display="flex" sx={{ marginTop: "2px" }}>
        <Typography
          variant="body1"
          fontWeight="bold"
          sx={{ color: grey[600], width: "135px", fontSize: "0.775rem" }}
        >
          Current Process:
        </Typography>
        <Typography variant="body1" fontWeight="bold" sx={{ color: grey[600], fontSize: "0.775rem" }}>
          {cardDetails.current_step_name}
        </Typography>
      </Box> */}
    </Box>
    
{/* BOM and Issue Item Form Container */}
<Box sx={{ display: "flex", gap: 2, mt: 1, width: "100%" }}>
  {/* BOM Details */}
  <Box sx={{ flex: expandedDrawer ? "0 0 400px" : "1", transition: "flex 0.3s ease-in-out" }}>
  {/* Tabs for BOM and Chemicals */}
  <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
      <Tabs value={selectedTab} onChange={(event, newValue) => setSelectedTab(newValue)}>
        {/* <Tab 
          label={`${bomOpen ? "▲" : "▼"} BOM Details`} 
          onClick={() => setBomOpen(!bomOpen)} // Toggle BOM details on click
        />
        <Tab 
          label={`${chemicalsOpen ? "▲" : "▼"} Chemicals`} 
          onClick={() => setChemicalsOpen(!chemicalsOpen)} // Toggle Chemicals section on click
        /> */}
        <Tab label="▲ BOM Details" />
        <Tab label="▲ Chemicals" />
        <Tab label="▲ Inventory" /> {/* New Inventory Tab */}
        <IconButton
          onClick={() => {
            // Function to refresh inventory data
            axios.get(`${process.env.REACT_APP_PJCBACKEND_URL}/api/productionlocinventory/quantities/all`)
              .then(res => {
                setInventoryData(res.data); // Store in state
              })
              .catch(err => console.error("Error fetching inventory quantities", err));
          }}
          sx={{ marginLeft: 2 }} // Add some margin for spacing
        >
          <Refresh />
        </IconButton>
      </Tabs>
    </Box>

    {/* Render content based on selected tab */}
    {selectedTab === 0 && (
    <Collapse in={bomOpen}>
      {/* <Box sx={{ borderBottom: `2px solid ${grey[300]}`, paddingBottom: 1 }}> */}
      <Box sx={{mt: 0.5, p: 0.5, border: "1px solid #ccc", borderRadius: 2}}>
        <Typography variant="h6" fontWeight="bold" sx={{ paddingTop: 1 }} >
          {cardDetails?.product_name}:
        </Typography>
        <ul style={{ listStyle: "none", padding: 0 }}>
  {bomDetails.length > 0 ? (
    bomDetails.map((bom, index) => {
      // console.log(`BOM Item: ${bom.part_name}, Part ID: ${bom.part_id}`); // Log BOM item details

      // Filter issued details for the current BOM item
      const relevantIssuedDetails = issuedDetails.filter(issued => issued.product_id === bom.part_id);

      // console.log("Issued Details:", issuedDetails);
      // console.log("Relevant Issued Details for", bom.part_name, ":", relevantIssuedDetails);

      // Calculate the total issued quantity for the current BOM item
      const totalIssuedQuantity = relevantIssuedDetails.reduce((sum, issued) => sum + parseInt(issued.quantity, 10), 0);
      const quantityRequired = Number(bom.quantity_required) * Number(cardDetails?.quantity || 0);
      
      const inventoryItem = inventoryData.find(item => String(item.RM_id) === String(bom.part_id));
      
      const availableQty = inventoryItem ? Number(inventoryItem.quantity) : 0;
      
      // console.log(">> totalIssuedQuantity:", totalIssuedQuantity);
      // console.log(">> quantityRequired:", quantityRequired);
      // console.log(">> availableQty:", availableQty);
      // console.log(">> isButtonDisabled:", totalIssuedQuantity >= quantityRequired || availableQty >= quantityRequired);

      // Determine if the button should be disabled
      // const isButtonDisabled = totalIssuedQuantity >= quantityRequired;
      const isButtonDisabled = totalIssuedQuantity >= quantityRequired || availableQty >= quantityRequired;

      return (
        <li 
          key={index} 
          style={{ 
            display: "flex", 
            alignItems: "center", 
            justifyContent: "space-between", 
            marginBottom: "4px",
            width: "100%"
          }}
        >
          <Typography 
            variant="body2" 
            sx={{ 
              flex: 1,  
              minWidth: "200px", 
              whiteSpace: "nowrap", 
              overflow: "hidden", 
              textOverflow: "ellipsis"
            }}
          >
            {bom.part_name} : Qty Req:{" "}
            {quantityRequired},
            {relevantIssuedDetails.length > 0 
              ? relevantIssuedDetails.map(issued => ` GRN ${issued.grn_no}(${issued.quantity})`).join(", ")
              : " Not Issued yet."}
          </Typography>

          <Button 
            variant="contained" 
            color="secondary" 
            size="small" 
            sx={{ 
              fontSize: "0.6rem", 
              pt: "1px", 
              pb: "1px", 
              pl: "0px",  
              pr: "0px"   
            }} 
            onClick={() => {
              setproductId(bom.part_id); 
              setIssueSource('bom'); // Set the source to BOM
              setExpandedDrawer(true);
            }}
            disabled={isButtonDisabled} // Disable the button based on the condition
          >
            Issue
          </Button>
          
        </li>
      );
    })
  ) : (
    <Typography variant="body2">No BOM details available for this product.</Typography>
  )}
</ul>
      </Box>
    </Collapse>
    )}

{selectedTab === 1 && (
  <Collapse in={chemicalsOpen}>
    <Box sx={{ mt: 0.5, p: 0.5, border: "1px solid #ccc", borderRadius: 2 }}>
      <Typography variant="h6" fontWeight="bold" sx={{ paddingTop: 1 }}>
        Chemicals:
      </Typography>
      {bomChemicals.length > 0 ? (
        <ul style={{ listStyle: "none", padding: 0 }}>
          {bomChemicals.map((chemical, idx) => {
            // Calculate the total issued quantity for the current chemical
            const relevantIssuedDetails = issuedDetails.filter(issued => issued.product_id === chemical.chemical_id);
            const totalIssuedQuantity = relevantIssuedDetails.reduce((sum, issued) => sum + parseInt(issued.quantity, 10), 0);

            const inventoryItem = inventoryData.find(item => String(item.RM_id) === String(chemical.chemical_id));
      
            const availableQty = inventoryItem ? Number(inventoryItem.quantity) : 0;

      // Determine if the button should be disabled
      // const isButtonDisabled = totalIssuedQuantity >= chemical.chemical_quantity; // Disable if issued quantity is greater than or equal to required quantity
      const isButtonDisabled = totalIssuedQuantity >= chemical.chemical_quantity || availableQty >= chemical.chemical_quantity;
             
            return (
              <li key={idx} style={{ 
                display: "flex", 
                alignItems: "center", 
                justifyContent: "space-between", 
                marginBottom: "4px",
                width: "100%"
              }}>
                <Typography 
                  variant="body2" 
                  sx={{ 
                    flex: 1,  
                    minWidth: "200px", 
                    whiteSpace: "nowrap", 
                    overflow: "hidden", 
                    textOverflow: "ellipsis"
                  }}
                >
                  {chemical.chemical_name} : Qty Req: {chemical.chemical_quantity}, 
                  {relevantIssuedDetails.length > 0 
                    ? relevantIssuedDetails.map(issued => ` GRN ${issued.grn_no}(${issued.quantity})`).join(", ")
                    : " Not Issued yet."}
                </Typography>
                <Button 
                  variant="contained" 
                  color="secondary" 
                  size="small" 
                  sx={{ 
                    fontSize: "0.6rem", 
                    pt: "1px", 
                    pb: "1px", 
                    pl: "0px",  
                    pr: "0px",
                    marginLeft: "10px" 
                  }} 
                  onClick={() => {
                    setproductId(chemical.chemical_id); // Set the product ID to the chemical ID
                    setIssueSource('chemical'); // Set the source to Chemical
                    setExpandedDrawer(true); // Open the drawer
                  }}
                  disabled={isButtonDisabled} // Disable the button based on the condition
                >
                  Issue
                </Button>
              </li>
            );
          })}
        </ul>
      ) : (
        <Typography variant="body2">No associated chemicals available.</Typography>
      )}
    </Box>
  </Collapse>
)}

{selectedTab === 2 && (
  <Collapse in={true}>
    <Box sx={{ mt: 0.5, p: 0.5 }}>
      {inventoryData.length > 0 ? (
        <TableContainer component={Paper} sx={{ maxHeight: 200, border: '1px solid #ccc' }}>
        <table style={{ width: "100%" }}>
          <thead>
            <tr>
              <th padding="none" style={{ fontSize: '0.8rem', textAlign: 'center', borderRight: '2px solid #ccc', borderBottom: "3px solid #ccc", borderTop: "2px solid #ccc", borderLeft: "2px solid #ccc" }}>RM Name</th>
              <th padding="none" style={{ fontSize: '0.8rem', textAlign: 'center', borderRight: '2px solid #ccc', borderBottom: "3px solid #ccc", borderTop: "2px solid #ccc", borderLeft: "2px solid #ccc" }}>Quantity</th>
            </tr>
          </thead>
          <tbody>
            {inventoryData
              .filter(item => 
                bomDetails.some(bom => String(bom.part_id) === String(item.RM_id)) || 
                bomChemicals.some(chemical => String(chemical.chemical_id) === String(item.RM_id))
              )
              .map((item, idx) => (
                <tr key={idx}>
                  <td padding="none" style={{ fontSize: '0.8rem', textAlign: 'center', borderRight: '1px solid #ccc', borderLeft: '2px solid #ccc', borderBottom: "1px solid #ccc" }}>{item.RM_name}</td>
                  <td padding="none" style={{ fontSize: '0.8rem', textAlign: 'center', borderRight: '2px solid #ccc', borderBottom: "1px solid #ccc" }}>{item.quantity}</td>
                </tr>
              ))}
          </tbody>
        </table>
        </TableContainer>
      ) : (
        <Typography variant="body2">No inventory data available.</Typography>
      )}
    </Box>
  </Collapse>
)}

</Box>

{/* Issue Item Form - Appears Beside BOM or Chemicals */}
{expandedDrawer && productId && (
  <Box sx={{ flex: 1, p: 1, border: "1px solid #ccc", borderRadius: 2 }}>
    <Typography variant="h6" sx={{ textAlign: "center", display: "block", marginBottom: 2 }}>
      Issue Item
    </Typography>

    <FormControl fullWidth>
      <TextField
        select
        label={issueSource === 'bom' ? "Selected Raw Material" : "Selected Chemical"}
        fullWidth
        value={productId}
        onChange={(e) => setproductId(e.target.value)}
        sx={{
          marginBottom: 1.5,
          "& .MuiInputBase-root": { minHeight: 36 },
          "& .MuiInputBase-input": { padding: "3px 6px", fontSize: "0.75rem" },
        }}
      >
        {issueSource === 'bom' ? (
          bomDetails.length > 0 ? (
            bomDetails.map((bom) => (
              <MenuItem key={bom.part_id} value={bom.part_id} disabled>
                {bom.part_name}
              </MenuItem>
            ))
          ) : (
            <MenuItem disabled>No BOM details available</MenuItem>
          )
        ) : (
          bomChemicals.length > 0 ? (
            bomChemicals.map((chemical) => (
              <MenuItem key={chemical.chemical_id} value={chemical.chemical_id} disabled>
                {chemical.chemical_name}
              </MenuItem>
            ))
          ) : (
            <MenuItem disabled>No chemicals available</MenuItem>
          )
        )}
      </TextField>

      {/* Select GRN */}
      <TextField
        select
        label="Select GRN"
        value={selectedGRN || ''}
        onChange={(e) => setSelectedGRN(e.target.value)}
        fullWidth
        sx={{
          marginBottom: 1.5,
          "& .MuiInputBase-root": { minHeight: 36 },
          "& .MuiInputBase-input": { padding: "3px 6px", fontSize: "0.75rem" },
        }}
      >
        <MenuItem value="" >
          Select GRN
        </MenuItem>
          {grnDetails.length > 0 ? (
              grnDetails
                .filter(grn => grn.balance_quantity >= 0) // Filter out negative quantities
                .sort((a, b) => new Date(a.grn_date) - new Date(b.grn_date)) // Sort by date
                .map((grn, index, arr) => {
                  // Determine if the current GRN should be disabled
                  const isDisabled = index > 0 && arr[index - 1].balance_quantity === 0 && grn.balance_quantity === 0;
                  return (
                    <MenuItem
                      key={grn.grn_no}
                      value={grn.grn_no}
                      disabled={isDisabled}
                    >
                      {`Quantity: ${grn.balance_quantity} | GRN No: ${grn.grn_no} | GRN Date: ${new Date(grn.grn_date).toLocaleDateString()}`}
                    </MenuItem>
                  );
                })
            ) : (
              <MenuItem disabled>No GRN details found.</MenuItem>
            )}
      </TextField>

      {/* Quantity */}
      <TextField
        label="Quantity"
        value={quantity}
        onChange={(e) => setQuantity(e.target.value)}
        fullWidth
        type="number"
        sx={{
          marginBottom: 2,
          "& .MuiInputBase-root": { minHeight: 36 },
          "& .MuiInputBase-input": { padding: "3px 6px", fontSize: "0.75rem" },
        }}
      />
    </FormControl>

    <Box sx={{ display: "flex", justifyContent: "center", gap: 1 }}>
      <Button
        onClick={() => handleUpdateQuantity('issue')}
        color="secondary"
        disabled={isSaving}
        size="small"
        sx={{ fontSize: "0.65rem", padding: "3px 6px" }}
      >
        Issue Now
      </Button>
      <Button
        color="error"
        size="small"
        sx={{ fontSize: "0.65rem", padding: "3px 6px" }}
        onClick={() => {
          setExpandedDrawer(false);
          setproductId(''); 
          setSelectedGRN(''); 
          setQuantity(''); 
        }}
      >
        Cancel
      </Button>
    </Box>
  </Box>
)}
     
</Box>

    {/* Progress Form Toggle */}
    {/* <Button
      fullWidth
      variant="outlined"
      sx={{ mt: 2, }}
      onClick={() => setProgressFormOpen(!progressFormOpen)}
    >
      Progress Card {progressFormOpen ? "▲" : "▼"}
    </Button> */}
    {/* <Collapse in={progressFormOpen}> */}
      {/* <Box sx={{ mt: 1, padding: 1, }}> */}
      {/* <Typography variant="body2" sx={{ textAlign: "center", display: "block" }}>
        Progress Card : {cardDetails.current_step_name || "Not Available"}
      </Typography> */}
      <ProgressCardForm 
        progressFormOpen={progressFormOpen} 
        setProgressFormOpen={setProgressFormOpen} 
        cardDetails={cardDetails} 
        departmentDetails={departmentDetails} 
        bomDetails={bomDetails} 
        bomChemicals={bomChemicals}
        setDrawerOpen={setDrawerOpen} 
        currentStepStatus={matchedStep} // Pass currentStep here
        setExpandedDrawer={setExpandedDrawer}
        steps={steps}
        operatorFullName={operatorFullName}
      />
      {/* </Box>
    </Collapse> */}

    {/* Close Button at Bottom */}
    {/* <Box sx={{ position: "absolute", bottom: 16, left: 0, width: "100%", padding: "0 16px" }}>
      <Button
        fullWidth
        variant="contained"
        sx={{
            backgroundColor: grey[200],
            color: "black",
            "&:hover": { backgroundColor: grey[250] },
            textTransform: "none",
           }}
        onClick={() => setDrawerOpen(false)}
      >
        Close
      </Button>
    </Box> */}

  </Box>
</Drawer>

    </div>
  );
};

export default ProcessSteps;
